/* eslint-disable */
import io       from 'socket.io-client'
import config   from './moramma-config.json'
import logger   from './logger'

const socketConnection = io(config['BASE_API']);

socketConnection.connect();

logger.debug('Socket.io started');

export default socketConnection;